var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgContato = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-90)",
    d: "M32.168 34.86c0 8.735 7.107 15.825 15.823 15.825 8.716 0 15.805-7.108 15.823-15.825v-9.035C63.814 17.09 56.707 10 47.99 10c-8.734 0-15.823 7.09-15.823 15.825v9.035Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M36.823 36.484c0 7.257 5.711 13.148 12.716 13.148 7.004 0 12.701-5.906 12.715-13.148v-7.507c0-7.258-5.711-13.149-12.715-13.149-7.019 0-12.716 5.891-12.716 13.149v7.507Z"
  }), React.createElement("path", {
    stroke: borderColor,
    d: "M63.23 35.457c0 4.713-1.544 8.453-4.21 11.015-2.667 2.564-6.506 3.995-11.178 3.995-4.672 0-8.456-1.43-11.069-3.992-2.612-2.56-4.106-6.3-4.106-11.018 0-1.11-.053-2.848-.105-4.596l-.002-.076c-.054-1.78-.107-3.563-.107-4.729 0-10.008 8.266-15.48 15.389-15.48 7.123 0 15.389 5.472 15.389 15.48v9.401Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M20.542 79.352C26.5 82.499 36.793 86 47.842 86c11.05 0 21.658-3.501 27.616-6.648 2.05-1.079 3.341-3.112 3.483-5.411.495-8.116-2.21-12.271-4.58-14.322-1.13-.99-2.58-1.698-4.401-2.14-6.188-1.485-12.233-5.964-12.304-6.035-6.542 3.753-13.552 3.283-20.094-.007-8.412 5.64-7.254 5.018-11.522 6.042-1.82.442-3.27 1.15-4.402 2.14-2.369 2.05-5.074 6.206-4.579 14.322.142 2.299 1.432 4.332 3.483 5.41Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    d: "M37.562 51.437c-.07.071-5.334 4.55-11.522 6.036-1.82.442-3.27 1.149-4.402 2.139-2.369 2.051-5.074 6.206-4.579 14.322.142 2.299 1.629 4.626 3.68 5.704 5.957 3.148 16.054 6.355 27.104 6.355s21.613-3.207 27.571-6.355c2.051-1.078 3.385-3.405 3.527-5.704.495-8.116-2.21-12.27-4.58-14.322-1.13-.99-2.58-1.697-4.401-2.14-6.188-1.485-12.233-5.964-12.304-6.035"
  }), React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    stroke: borderColor,
    d: "M47.08 13.002c-6.788 0-14.272 5.309-14.744 14.982v8.283h-3.428c-1.569 0-2.84-1.344-2.84-3.002v-2.278c0-1.658 1.271-3.002 2.84-3.002h.294C29.68 16.308 39.072 10 47.081 10c8.008 0 17.401 6.308 17.878 17.985h.583c1.569 0 2.84 1.344 2.84 3.002v2.278c0 1.658-1.271 3.002-2.84 3.002h-.599c-.708 3.89-3.854 9.07-10.71 10.495-.25 1.565-1.538 2.758-3.09 2.758-1.731 0-3.135-1.483-3.135-3.313s1.404-3.313 3.135-3.313c.872 0 1.66.376 2.229.983 5.714-1.053 8.153-5.149 8.742-7.961v-7.931c-.47-9.674-8.245-14.982-15.033-14.982Z",
    clipRule: "evenodd"
  }));
};
export default SvgContato;